// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2CftV","titlePart":"style_titlePart__3Fai-","pagesGrid":"style_pagesGrid__Y_b8f","pageItem":"style_pageItem__3D991"};